"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KBtcAmount = exports.KBtc = void 0;
const monetary_1 = require("../monetary");
const bitcoin_1 = require("./bitcoin");
exports.KBtc = Object.assign(Object.assign({}, bitcoin_1.Bitcoin), { ticker: "KBTC" });
class KBtcAmount extends monetary_1.MonetaryAmount {
    constructor(amount) {
        super(exports.KBtc, amount);
    }
    withAmount(amount) {
        const Cls = this.constructor;
        return new Cls(amount);
    }
}
exports.KBtcAmount = KBtcAmount;
KBtcAmount.zero = () => new KBtcAmount(0);
